export const NUMBER_OF_IMAGES_WITH_HIGH_PRIORITY = 2
export const THREE_DIFY_TILE_POSITIONS = [5, 26, 56]
